/** Backend limit for organisation `organisationDetails.notes`. */
export const ORGANISATION_NOTES_MAX_LENGTH = 10_000;

export function isOrganisationNotesWithinLimit(notes: string | undefined): boolean {
  return (notes ?? '').length <= ORGANISATION_NOTES_MAX_LENGTH;
}
